import type { ElementRenderer } from './index.js';

const customRenderers: Record<string, ElementRenderer<any>> = Object.create(null);

export function registerSurfaceElementRenderer(
    type: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderer: ElementRenderer<any>
) {
    customRenderers[type] = renderer;
}

export function getCustomRenderers() {
    return customRenderers;
}


